import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100 aspect-[3/4]">
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩漫在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-md">
            {comic.status}
          </span>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-white text-xs leading-relaxed line-clamp-3">{comic.description}</p>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-accent-500 flex items-center gap-0.5">
            <i className="ri-star-fill w-3 h-3 flex items-center justify-center"></i>
            {comic.rating}
          </span>
        </div>
        <p className="text-xs text-foreground-400 mt-0.5">
          更新至 {comic.chapters.length} 话
        </p>
      </div>
    </Link>
  );
}